import { render, staticRenderFns } from "./custom-element.vue?vue&type=template&id=2512ca65&scoped=true&"
import script from "./custom-element.vue?vue&type=script&lang=js&"
export * from "./custom-element.vue?vue&type=script&lang=js&"
import style0 from "./custom-element.vue?vue&type=style&index=0&id=2512ca65&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2512ca65",
  null
  
)

export default component.exports